import React from 'react';
import classes from './AlertError.module.css';
import Alert from '../../UI/Alert/Alert';
import Button from '../../UI/Button/Button';
import strings from '../../../assets/localization';

const AlertError = (props) => {
  let msg;
  if (Array.isArray(props.errorMessage)) {
    const arr = [];
    for (let i = 0; i < props.errorMessage.length; i++) {
      arr.push(<span key={i}>{props.errorMessage[i]}</span>);
    }
    msg = arr;
  } else {
    msg = props.errorMessage;
  }

  return (
    <Alert>
      <div className={classes.ErrorTextWrapper}>{msg}</div>
      <Button clicked={props.dismissAlert}>{props.btnTxt ? props.btnTxt : strings.Close}</Button>
    </Alert>
  );
};

export default AlertError;



// WEBPACK FOOTER //
// ./src/components/Auth/AlertError/AlertError.js